// Set the url of the page hero banner by from an img tag (for easier changing out on SE)

(function($){
    $(function(){
        var $bannerImage = $('.zn-page-hero #pageHero-setBannerImage');
        
        if ($bannerImage.length){
            var $banner = $bannerImage.closest('.zn-page-hero'),
                src = $bannerImage.attr('src');

            if (src.length && $banner.length){
                $banner.css('background-image', 'url(' + src + ')');
            }
        }
    });  
})($JQ);